import React from "react";
import { default as MuiAutocomplete } from "@mui/material/Autocomplete";

function Autocomplete(props) {
  return <MuiAutocomplete {...props} />;
}

export default Autocomplete;
